// extracted by mini-css-extract-plugin
export default {"mCard":"gF-z","image":"hF-z","imageNoBackground":"iF-z","imageHasCategory":"jF-z","fullWidth":"kF-z"};